import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=4f723cf0&scoped=true&"
import script from "./NewList.vue?vue&type=script&lang=js&"
export * from "./NewList.vue?vue&type=script&lang=js&"
import style0 from "./NewList.vue?vue&type=style&index=0&id=4f723cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f723cf0",
  null
  
)

export default component.exports